import { useQuery } from "@tanstack/react-query";
import { comUltimoConhecido } from "../offline/ultimoConhecido";
import { api } from "./cliente";
import type { CaixaDetalhe } from "./tipos";

export const CHAVE_CAIXA_ATUAL = ["caixa-atual"] as const;

/** Caixa aberto do usuário logado (`null` se não houver). Sem internet, vale o último conhecido. */
export function useCaixaAtual() {
  return useQuery({
    queryKey: CHAVE_CAIXA_ATUAL,
    queryFn: () =>
      comUltimoConhecido("caixa-atual", () => api<{ caixa: CaixaDetalhe | null }>("/caixas/atual").then((r) => r.caixa)),
  });
}
